import { x } from '@xstyled/styled-components';
import React, { FC } from 'react';

export const Checkbox: FC<{
  checked: boolean;
  onChange: () => void;
}> = ({ children, checked, onChange }) => {
  return (
    <x.label display="flex" gap="sm" alignItems="flex-start">
      <x.input
        position="absolute"
        left="-100vw"
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <x.div
        w="20px"
        h="20px"
        minWidth="20px"
        minHeight="20px"
        borderRadius="50%"
        borderColor="accentDark"
        borderWidth="2px"
        backgroundColor={checked ? 'accentDark' : 'white'}
        color="white"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {checked ? '✔' : ''}
      </x.div>
      {children}
    </x.label>
  );
};
